export enum ProductCheckInFieldKey {
  OrderProductCheckIn = "order-product-check-in",
  NonOrderProductCheckIn = "non-order-product-check-in"
}
